import Typography from "@/components/ui/typography";
import MenuButton from "@/pages/Home/setting/_components/MenuButton";
import { Link } from "@tanstack/react-router";
import FaceIdButton from "./_components/FaceIdButton";
import {
	KASHU_PRIVACY_POLICY_URL,
	PAYOVA_TERMS_OF_SERVICE_URL,
} from "@/constants/common-constants";
import { getHost } from "@/lib/utils";

export function SecurityPage() {
	const host = getHost();

	function getPrivacyPolicyUrl() {
		if (host === "payova") {
			return PAYOVA_TERMS_OF_SERVICE_URL;
		}

		return KASHU_PRIVACY_POLICY_URL;
	}

	return (
		<div>
			<Typography variant={"h5"}>Security Settings</Typography>
			<div className="mt-4">
				<Link to="/main/setting/security/change-password">
					<MenuButton fontWeight="medium" label="Change Password" />
				</Link>
				<FaceIdButton />
				<Link to={"/main/setting/security/change-pin"}>
					<MenuButton fontWeight="medium" label="4-digit PIN" />
				</Link>
				<a href={getPrivacyPolicyUrl()} rel="noreferrer" target="_blank">
					<MenuButton fontWeight="medium" label="Privacy Policy" />
				</a>
				<Link to={"/main/setting/security/checklist"}>
					<MenuButton fontWeight="medium" label="Checklist" />
				</Link>
			</div>
		</div>
	);
}
